import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import InventoryCountsTable from "@/components/inventory-counts/inventory-counts-table";

const searchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/inventory-counts/")({
  validateSearch: searchSchema,
  component: InventoryCountsPage,
});

function InventoryCountsPage() {
  const searchParams = Route.useSearch();
  return (
    <RouteGuardPermissions
      permissions={[{ module: "inventory_counts", actions: ["read"] }]}
    >
      <div className="space-y-4">
        <InventoryCountsTable
          currentPage={searchParams.page}
          basePath="/inventory-counts"
          searchParams={searchParams}
        />
      </div>
    </RouteGuardPermissions>
  );
}
